import { useState, useMemo } from "react";

export const usePaginate = (data = [], initialRowsPerPage = 10) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(initialRowsPerPage);

  const totalDocs = data?.length ?? 0;
  const totalPages = Math.ceil(totalDocs / rowsPerPage);

  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return data?.slice(startIndex, endIndex);
  }, [data, currentPage, rowsPerPage]);

  const handlePageChange = page => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setRowsPerPage(newPerPage);
    setCurrentPage(page);
  };

  const handleInputPagination = page => {
    setCurrentPage(page);
  };

  const resetPagination = () => {
    setCurrentPage(1);
  };

  return {
    paginatedData,

    currentPage,
    rowsPerPage,
    totalDocs,
    totalPages,

    handlePageChange,
    handlePerRowsChange,
    handleInputPagination,
    resetPagination,
  };
};
